export function downloadBlob(blob: Blob, name: string, fileFormat?: string) {
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.style.display = 'none';
  link.download = fileFormat ? `${name}.${fileFormat}` : name;
  document.body.appendChild(link);
  link.click();
}
